import type { AnchorHTMLAttributes, ButtonHTMLAttributes, ReactNode } from "react";
type Props = { children: ReactNode; variant?: "primary"|"secondary"|"gold"; href?: string } &
  ButtonHTMLAttributes<HTMLButtonElement> & AnchorHTMLAttributes<HTMLAnchorElement>;
export function Button({ children, variant="primary", href, className="", ...props }: Props) {
  const classes = `pz-button pz-button--${variant} ${className}`.trim();
  return href ? <a className={classes} href={href} {...props}>{children}</a>
    : <button className={classes} {...props}>{children}</button>;
}
